import { concatLeasesAsPremises } from '@/modules/ccd/tenancy/utils'
import store from '@/store/index'
import lodash from 'lodash'

/** Prefer HOTB snapshot column; fall back to joined tenancy value when snapshot is absent. */
function hotbSnapshot (hotb, snapshot, tenancyPath) {
  if (snapshot) return snapshot
  return lodash.get(hotb, tenancyPath)
}

export function getHotbCompanyName (hotb) {
  return hotbSnapshot(hotb, hotb.companyName, 'tenancy.company.name')
}

export function getHotbTradeName (hotb) {
  return hotbSnapshot(hotb, hotb.tradeName, 'tenancy.tradeName')
}

export function getHotbPremises (hotb) {
  return hotb.premises || concatLeasesAsPremises(lodash.get(hotb, 'tenancy', {}))
}

export function updateCompanyNameAndTradeNameIfEmpty () {
  const currentHotb = store.getters['hotb/currentHotb']
  if (!currentHotb.companyName) {
    store.commit('hotb/HOTB_UPDATE_FIELD_PATH', {
      path: ['companyName'], newValue: getHotbCompanyName(currentHotb) })
  }
  if (!currentHotb.tradeName) {
    store.commit('hotb/HOTB_UPDATE_FIELD_PATH', {
      path: ['tradeName'], newValue: getHotbTradeName(currentHotb) })
  }
}
